module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl2-50.d7de4717.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-B-lvl2-50.png
// module id = 3381
// module chunks = 11